import React, { useEffect, useRef, useState } from "react";
import rdaLogo from "../../asset/rda-web-logo 1.png";
import { NavLink, useLocation } from "react-router-dom";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import MobileNavbar from "./MobileNavbar";

const directoratesCard = [
  "/administration",

  "/finance",

  "/engineering",

  "/land-development-estate-management",

  "/estate-management",

  "/metropolitan-planning-traffic-engineering",

  "/land-building-control",

  "/architecture",

  "/IT-wing",

  "/PR-wing",
];

const navTab = [
  { name: "Home", link: "/" },
  {
    name: "About Us",
    option: true,
    options: [
      { optionName: "About RDA", optionLink: "/about-rda" },
      { optionName: "About Rawalpindi", optionLink: "/rawalpindi" },
      { optionName: "About Authority", optionLink: "/authority" },
      { optionName: "About Management", optionLink: "/management" },
      { optionName: "RDA Organogram", optionLink: "/organogram" },
    ],
    link: "/about-us",
    paths: [
      "/about-us",
      "/about-rda",
      "/rawalpindi",
      "/authority",
      "/management",
      "/organogram",
    ],
  },
  {
    name: "Directorates",
    link: "/directorates-2",
    option: true,
    options: [
      {
        optionName: "Administration Directorate",
        optionLink: "/administration",
      },
      {
        optionName: "Finance Directorate",
        optionLink: "/finance",
      },
      {
        optionName: "Engineering Directorate",
        optionLink: "/engineering",
      },

      {
        optionName: "Land Development Directorate",
        optionLink: "/land-development-estate-management",
      },
      {
        optionName: "Estate Management Directorate",
        optionLink: "/estate-management",
      },
      {
        optionName: "Metropolitan Planning & Traffic Engineering Directorate",
        optionLink: "/metropolitan-planning-traffic-engineering",
      },
      {
        optionName: "Land Use & Building Control Directorate",
        optionLink: "/land-building-control",
      },
      {
        optionName: "Architecture Directorate",
        optionLink: "/architecture",
      },
      {
        optionName: "IT Wing",
        optionLink: "/IT-wing",
      },
      {
        optionName: "PR Wing",
        optionLink: "/PR-wing",
      },
    ],
    paths: [
      "/administration",

      "/finance",

      "/engineering",

      "/land-development-estate-management",

      "/estate-management",

      "/metropolitan-planning-traffic-engineering",

      "/land-building-control",

      "/architecture",

      "/IT-wing",

      "/PR-wing",
    ],
  },
  { name: "Public Notices", link: "/public-notices" },
  { name: "Projects", link: "/project-2" },
  {
    name: "Private Housing Societies",
    option: true,
    options: [
      { optionName: "Approved Housing Society", optionLink: "/ahs" },
      { optionName: "Unapproved Housing Society", optionLink: "/uhs" },
      { optionName: "Illegal Housing Society", optionLink: "/ihs" },
    ],
    link: "/private-housing-schemes",
    paths: ["/private-housing-schemes", "/ahs", "/uhs", "/ihs"],
  },
  { name: "Downloads", link: "/downloads" },
  { name: "Media", link: "/media" },
  { name: "Blogs", link: "/blogs" },
];

const Navbar = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [activeParentIndex, setActiveParentIndex] = useState(null);
  const location = useLocation();
  useEffect(() => {
    const handler = (event) => {
      if (!event.target.closest(".dropdown-container") && openIndex !== null) {
        setOpenIndex(null);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [openIndex]);

  const timeoutRef = useRef(null);

  const handleMouseEnter = (i) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setOpenIndex(i);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setOpenIndex(null);
    }, 1000);
  };

  useEffect(() => {
    setOpenIndex(null);
    setActiveParentIndex(null);
  }, [location.pathname]);

  useEffect(() => {
    navTab.forEach((nav, i) => {
      const isParentActive =
        nav.option && nav.paths?.includes(location.pathname);
      if (isParentActive) {
        setActiveParentIndex(i);
      }
    });
  }, [location.pathname]);

  return (
    <div className="sticky top-0 z-50 flex justify-between items-center xl:px-7 px-3 xl:py-3 py-2 bg-white ">
      <img src={rdaLogo} className="xl:w-16 lg:w-14 md:w-12 w-10 " alt="" />

      <div className="hidden lg:flex items-center xl:gap-5 gap-3 xl:text-[14px] text-[12px] font-medium">
        {navTab.map((nav, i) =>
          nav.option ? (
            <div
              onMouseEnter={() => handleMouseEnter(i)}
              onMouseLeave={handleMouseLeave}
              className="relative dropdown-container "
              key={i}
            >
              <NavLink
                to={`${nav.link}`}
                className={`flex items-center xl:gap-2 gap-1 cursor-pointer hover:text-[#00643B] ${
                  activeParentIndex === i ? "text-[#00643B] " : "text-[#9A9A9A]"
                }`}
              >
                {nav.name}{" "}
                <MdOutlineKeyboardArrowDown className=" cursor-pointer" />
              </NavLink>
              {openIndex === i && (
                <div class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-2xl ">
                  <div className=" flex flex-col items-start gap-2 p-2">
                    {nav?.options?.map((opt, oi) => (
                      <NavLink
                        key={oi}
                        to={`${opt.optionLink}`}
                        className={`px-2 py-1 ${
                          location.pathname === opt.optionLink
                            ? "text-[#00643B]"
                            : "text-[#9A9A9A]"
                        }  hover:text-[#00643B]`}
                      >
                        {opt.optionName}
                      </NavLink>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <NavLink
              to={`${nav.link}`}
              key={i}
              className={`${
                location.pathname === nav.link
                  ? "text-[#00643B]"
                  : "text-[#9A9A9A]"
              }   cursor-pointer hover:text-[#00643B]`}
            >
              {nav.name}
            </NavLink>
          )
        )}
      </div>

      <div className="hidden lg:flex items-center xl:gap-3 gap-2">
        <NavLink
          to={`https://cms.rda.gop.pk/`}
          target="_blank"
          className="xl:px-3 px-2 xl:py-2 py-1.5 xl:text-[1rem] lg:text-[.85rem] text-[.8rem] xl:rounded-xl rounded-lg bg-transparent border border-[#00643B] font-semibold text-[#00643B] hover:bg-[#00643B]  hover:text-white"
        >
          Lodge a Complaint
        </NavLink>
       <a
  href="https://digital-rda.gop.pk/auth/signin"
  target="_blank"
  rel="noopener noreferrer"
  className="xl:px-3 px-2 xl:py-2 py-1.5 xl:text-[1rem] lg:text-[.85rem] text-[.8rem] xl:rounded-xl rounded-lg bg-[#00643B] border border-[#00643B] font-semibold text-white hover:text-[#00643B] hover:bg-white"
>
  Digital RDA
</a>

      </div>
      <div className="flex lg:hidden ">
        <MobileNavbar navTab={navTab} />
      </div>
    </div>
  );
};

export default Navbar;
